(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('InboxNewController', InboxNewController);

    InboxNewController.$inject = ['$scope', '$stateParams', '$timeout', '$uibModalInstance', 'entity', 'Principal', 'Message', 'Discussion', 'User', 'Director'];

    function InboxNewController($scope, $stateParams, $timeout, $uibModalInstance, entity, Principal, Message, Discussion, User, Director) {
        var vm = this;
        vm.discussion = entity;
        vm.me = {};
        vm.to = "";
        vm.sale = {}; // Selected salesman
        vm.sales = []; // List of my sales (dg), my fellow sales (salesman) or list of users (admin)
        vm.myDirector = {}; // Only if user is salesman

        vm.clear = clear;
        vm.save = save;

        // Add me by default as a member of the discussion
        Principal.identity().then(function (me) {
            vm.me = me;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        Principal.hasAuthority('ROLE_COMMERCIAL').then(function (isSale) {
            Principal.hasAuthority('ROLE_DG').then(function (isDG) {
                if (isSale) {
                    console.log('sale');
                    User.mySuperior().$promise.then(getMyDirectorCompleted);
                    User.sameSuperior().$promise.then(getMyFellowSalesCompleted);
                } else if (isDG) {
                    console.log('dg');
                    Director.querySales().$promise.then(getMySalesCompleted);
                } else {
                    console.log('admin');
                    User.query(getAllUsersCompleted);
                }
            });
        });

        function getMyDirectorCompleted(myDirector) {
            vm.myDirector = myDirector;
        }

        function getMySalesCompleted(sales) {
            vm.sales = sales;
        }

        function getMyFellowSalesCompleted(sales) {
            var res = [];
            sales.forEach(function (sale) {
                if (sale.id !== vm.me.id) {
                    res.push(sale);
                }
            });
            vm.sales = res;
        }

        function getAllUsersCompleted(users) {
            vm.sales = users;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log('saving');
            switch (vm.to) {
                case 'admin':
                    vm.discussion.admin = true;
                    vm.discussion.members = [
                        vm.me
                    ];
                    break;
                case 'director':
                    vm.discussion.admin = false;
                    vm.discussion.members = [
                        vm.me,
                        vm.myDirector
                    ];
                    break;
                case 'sale':
                    if (vm.sale.id) {
                        if (vm.me.authorities.indexOf("ROLE_ADMIN") > -1) {
                            vm.discussion.admin = true;
                            vm.discussion.members = [
                                vm.sale
                            ];
                        } else {
                            vm.discussion.admin = false;
                            vm.discussion.members = [
                                vm.sale,
                                vm.me
                            ];
                        }
                    } else {
                        vm.isSaving = false;
                        return;
                    }
            }
            console.log(vm.discussion);
            Discussion.save(vm.discussion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:discussionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
